module.exports = __webpack_public_path__ + "logo.png?d6f00bfca2c051f916b2c8730885cc28";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 27
// module chunks = 0